import React from "react";
import Navbar from "../Navbar/Navbar";
import MobileNavbar from "../MobileNavbar/MobileNavbar";
import styles from "./hero.module.scss";
// import { Link } from "react-router-dom";
// import hero_section_image from '../../../assets/new-banners/square_banner.png'
// import hero_section_image from '../../../assets/new-banners/providing radiology and diagnostic center with PACS.gif'
import mill_v from '../../../assets/new-banners/providing radiology and diagnostic center with PACS.mp4'
import { GrFormNextLink } from "react-icons/gr";




const Hero = () => {
  return (
    <section className={styles.hero_mainContainer}>
      <Navbar />
      <MobileNavbar />
      <div className={styles.hero_content_container}>           
          <div className={styles.hero_heading}>
            <h1>Empowering Healthcare with Small Innovations, Big Achievements</h1>
            <p>At MILLENSYS, we believe that minor innovations pave the way for significant advancements. With advanced solutions like PACS, VNA, RIS, Polyclinic Solution, Teleradiology, and Mobile Apps, we are transforming healthcare delivery in the Saudi market. From seamless imaging management to remote diagnostics and patient-centered care, our technology empowers healthcare providers to achieve more, one step at a time. Together, let’s turn small innovations into remarkable achievements.</p>
            <button className={styles["glow-on"]} >
              <a href="#contact_us_form" className={styles["glow-on-link"]} >Request a Free Demo<GrFormNextLink /></a>
            </button>
          </div>
          <div className={styles.hero_media}>
            {/* <img src={hero_section_image} alt="hero_section_image" loading="lazy"/> */}
            <div className={`${styles["container"]} `}>
                    <video    src={mill_v} autoPlay loop muted ></video>
                </div>
          </div>
      </div>
    </section>
  );
};

export default Hero;
//controls
